<template>
    <section>
        <div class="content">
            <div class="card card-default">
                <div class="card-header">
                    <h3 class="card-title">
                        <span>
                            <strong><i class="fa-solid fa-magnifying-glass"></i> {{ $t('labels.search') }}</strong>
                        </span>
                    </h3>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"
                            v-bind:title="$t('labels.collapse')">
                            <i class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <!-- SEARCH CONTENT INPUT-->
                <div class="card-body">
                    <div class="row mb-2 row-cols-1 row-cols-sm-1 row-cols-md-4 row-cols-lg-4 row-cols-xl-4">
                        <div class="col mb-3">
                            <TheSelect id="" title="Số dòng" :options="pageOptions" :initialValue="pageSize.toString()"
                                @onChange="(v) => onChangePageOptions(v)" />
                        </div>
                        <div class="col mb-3">
                            <label>
                                Phân hệ
                            </label>
                            <select id="phanHe_sOptions" class="form-control select2bs4" style="width: 100%">
                                <option value="">--- Tất cả Phân hệ ---</option>
                                <option v-for="item in category_PHANHE" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col mb-3">
                            <label>
                                Người dùng
                            </label>
                            <select id="nguoiDung_sOptions" class="form-control select2bs4" style="width: 100%">
                                <option value="">--- Tất cả Người dùng ---</option>
                                <option v-for="item in category_NGUOIDUNG" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </option>
                            </select>
                        </div>
                        <div class="col mb-3">
                            <TheDateRangePicker title="Ngày đăng nhập" placeholder="Tìm theo ngày đăng nhập"
                                :isReadonly="false" :isRequire="false" :key="tempKey" :isTextInput="false"
                                @onChangeDate="(d) => onSearchNgayLogin(d)" />
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </section>
    <section>
        <div class="content">
            <div class="card card-primary card-outline">
                <div class="card-header">
                    <h3 class="card-title">
                        <i class="fas fa-tag"></i>&nbsp;
                        <b v-if="sType_List == 1">Danh sách hiện hành</b>
                        <b v-if="sType_List == 2">Danh sách đã xóa</b>
                    </h3>
                    <div class="card-tools">
                        <button v-if="sType_List == '2'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách hiện hành" @click="changeCurrentTypeSearch()">
                            <i class="far fa-list-alt" style="color: #28a745;"></i>
                        </button>

                        <button v-if="sType_List == '1'" type="button" class="btn btn-tool"
                            title="Chuyển sang danh sách đã xóa" @click="changeCurrentTypeSearch()">
                            <i class="fas fa-list-alt" style="color: #df132e;"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-toggle="dropdown"
                            v-bind:title="$t('labels.cogs')">
                            <i class="fas fa-cogs"></i>
                            <div class="input-group-prepend">
                                <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                    <a v-if="sType_List == '2'" class="dropdown-item text-green" href="#"
                                        @click="confirmList('restore')" :title="$t('labels.restore')"><i
                                            class="fas fa-undo"></i>&nbsp;&nbsp;{{ $t('labels.restore') }}</a>
                                    <div class="dropdown-d ivider"></div>
                                    <a v-if="sType_List == '1'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('delete')" :title="$t('labels.delete')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.delete')
                                        }}</a>
                                    <a v-if="sType_List == '2'" class="dropdown-item text-red" href="#"
                                        @click="confirmList('deleteReal')" :title="$t('labels.deleteReal')"><i
                                            class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;{{ $t('labels.deleteReal')
                                        }}</a>

                                </div>
                            </div>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <div class="table-responsive p-0">
                        <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>

                        <table class="table table-hover" id="table">
                            <thead>
                                <tr>
                                    <th class="col10"></th>
                                    <th class="col50">
                                        <div class="custom-control custom-checkbox">
                                            <input class="custom-control-input" type="checkbox" id="checkboxAll"
                                                @click="selectAllRows($event)">
                                            <label for="checkboxAll" class="custom-control-label"></label>
                                        </div>
                                    </th>
                                    <th class="col50">Tài khoản đăng nhập</th>
                                    <th class="col50">Thuộc về</th>
                                    <th class="col50">Phân hệ đăng nhập</th>
                                    <th class="col50">Thời gian</th>
                                    <th class="col50"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in items" :key="item.loginHistoryId">
                                    <td></td>
                                    <td @click="selectRow(item.loginHistoryId)" style="cursor: pointer;"
                                        :title="$t('labels.selectItem')">
                                        <span v-if="(csList.includes(item.loginHistoryId))" aria-hidden="true"
                                            class="text-primary">&check;</span>
                                        <span v-else aria-hidden="true">&nbsp;</span>
                                    </td>
                                    <td>{{ item.userName }}</td>
                                    <td>{{ item.hoTen }}</td>
                                    <td>{{ item.appName }}</td>
                                    <td>{{ item.loginTime }}</td>
                                    <td>
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detailNguoiDung(item, 'detail')" title="Xem thông tin người dùng">
                                            <i class="fas fa-user text-secondary"></i>
                                        </button>&nbsp;
                                        <button type="button" size="sm" class="btn btn-outline-primary btn-xs"
                                            v-on:click="detail(item, 'detail')" title="Xem chi tiết">
                                            <i class="fas fa-eye text-secondary"></i>
                                        </button>&nbsp;
                                        <button type="button" size="sm" class="btn btn-outline-danger btn-xs"
                                            v-on:click="detail(item, 'delete')" title="Xóa">
                                            <i class="fas fa-trash-alt"></i>
                                        </button>&nbsp;
                                        <button v-if="sType_List == 2" type="button" size="sm"
                                            class="btn btn-outline-warning btn-xs" v-on:click="detail(item, 'restore')" title="Khôi phục" >
                                            <i class="fas fa-undo"></i>
                                        </button>&nbsp;

                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                </div>

                <div class="card-footer clearfix">
                    <div class="row">
                        <div class="col-md-6">
                            <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng
                            </div>
                            <div v-else>Không có dữ liệu</div>
                        </div>
                        <div class="col-md-6">
                            <div class="float-right">
                                <ul class="pagination pagination-rounded">
                                    <paginate :page-count="pageCount" v-model="pageNumber" :page-range="3"
                                        :margin-pages="2" style="cursor: pointer;" :click-handler="handlePageChange"
                                        :prev-text="'Trở lại'" :next-text="'Kế đến'" :container-class="'pagination'"
                                        :page-class="'page-item'">
                                    </paginate>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="modal fade" id="insUpdModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-primary">{{ title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hideModal()">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Lịch sử dăng nhập ID" :initialValue="model.loginHistoryId"
                                        v-model="model.loginHistoryId" :isReadOnly="isReadonly" :isRequire=false
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Tài khoản đăng nhập" :initialValue="model.userName"
                                        v-model="model.userName" :isReadOnly="isReadonly" :isRequire=false
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Thuộc về" :initialValue="model.hoTen" v-model="model.hoTen"
                                        :isReadOnly="isReadonly" :isRequire=false :isMultipleLine="false"
                                        :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Thời gian đăng nhập" :initialValue="model.loginTime"
                                        v-model="model.loginTime" :isReadOnly="isReadonly" :isRequire=false
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12">
                                    <TheInputText title="Phân hệ đăng nhập" :initialValue="model.appName"
                                        v-model="model.appName" :isReadOnly="isReadonly" :isRequire=false
                                        :isMultipleLine="false" :key="tempKey" />
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hideModal()">&nbsp;Đóng</button>

                            <button type="button" class="pull-right" :class="styleButton" v-if="code != 'detail'"
                                @click="onSubmit();">&nbsp;{{ title }}</button>
                        </div>
                    </div>

                </div>
            </div>

            <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelRec">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">Lịch sử đăng nhập ID
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.loginHistoryId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tài khoản đăng nhập ID
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.userId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tài khoản đăng nhập
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.userName }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Thuộc về
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.hoTen }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Thời gian đăng nhập
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.loginTime }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Phân hệ đăng nhập ID
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.appId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Phân hệ đăng nhập
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.appName }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Device
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.device }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Browser
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.browser }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Platform
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelRec.platform }}&nbsp;</b>
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


            <div class="modal fade" id="detailUserModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">Chi tiết</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupUserDetail">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row" v-if="modelNguoiDung">
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <div>
                                        <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Thông tin chung:</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Tài khoản ID:
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.userId }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Tên tài khoản
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.userName }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Giới tính
                                        <b class="d-block" v-if="modelNguoiDung.gioiTinh == 0">&nbsp;&nbsp;&nbsp;Nam&nbsp;</b>
                                        <b class="d-block"
                                            v-else-if="modelNguoiDung.gioiTinh == 1">&nbsp;&nbsp;&nbsp;Nam&nbsp;</b>
                                        <b class="d-block" v-else>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Số điện thoại
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.sdt }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Đơn vị
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenDonVi }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Chức danh
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenChucDanh }}&nbsp;</b>
                                    </p>

                                    <p class="text-sm">Tình trạng khóa
                                        <b class="d-block" v-if="modelNguoiDung.lockoutEnabled == 1">&nbsp;&nbsp;&nbsp;Đang bị
                                            Khóa - Thời gian khóa: {{ modelNguoiDung.lockoutTime }}&nbsp;</b>
                                        <b class="d-block"
                                            v-else-if="modelNguoiDung.lockoutEnabled == 0">&nbsp;&nbsp;&nbsp;Không bị
                                            khóa&nbsp;</b>
                                        <b class="d-block" v-else>&nbsp;&nbsp;&nbsp;&nbsp;</b>
                                    </p>

                                </div>
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <div>
                                        <hr />
                                        <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Địa chỉ:</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Quận huỵên
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenQuanHuyen }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Phường xã
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenPhuongXa }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Khóm ấp
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenKhomAp }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Tổ dân phố
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenToDanPho }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Đường phố
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.tenDuongPho }}&nbsp;</b>
                                    </p>
                                    <p class="text-sm">Số nhà
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.soNha }}&nbsp;</b>
                                    </p>
                                </div>

                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <p class="text-sm">Địa chỉ
                                        <b class="d-block">&nbsp;&nbsp;&nbsp;{{ modelNguoiDung.diaChi }}&nbsp;</b>
                                    </p>
                                </div>
                                <div class="col-12 col-md-12 col-lg-12 order-1 order-md-2">
                                    <div>
                                        <hr />
                                        <p class="text-sm"><i class="fas fa-caret-right"></i> <b>Quyền tài khoản:</b>
                                        </p>
                                    </div>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">
                                    <p class="text-sm">Phân hệ
                                        <b class="d-block" v-if="modelNguoiDung.appInfo" v-for="item in modelNguoiDung.appInfo"
                                            :key="item.appId">
                                            &nbsp;&nbsp;&nbsp;- {{ item.appName }}
                                        </b>&nbsp;
                                    </p>
                                </div>
                                <div class="col-6 col-md-6 col-lg-6 order-1 order-md-2">

                                    <p class="text-sm">Danh sách quyền
                                        <b class="d-block" v-if="modelNguoiDung.roleInfo" v-for="item in modelNguoiDung.roleInfo"
                                            :key="item.id">
                                            &nbsp;&nbsp;&nbsp;- {{ item.ten }}
                                        </b>&nbsp;
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <div class="modal fade" id="confirmcsListModal" data-keyboard="false" data-backdrop="static">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h4 class="modal-title text-success">{{ csList_Title }}</h4>
                            <button type="button" class="close" aria-label="Close" @click="hidePopupconfirmcsListModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <p class="text-sm">Bạn có chắc chắn <b>{{ csList_Title }}</b> các dữ liệu đã chọn?</p>
                            </div>
                        </div>
                        <div class="modal-footer justify-content-between">
                            <button type="button" class="btn btn-outline-dark pull-left"
                                @click="hidePopupconfirmcsListModal">&nbsp;{{
                                    $t('buttons.close') }}</button>
                            <button type="button" class="btn btn-outline-danger pull-right"
                                @click=" onSubmitList();">&nbsp;{{ csList_Title }}</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>


</template>
<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import moment from "moment"
import { common } from '@/helper/common';
import TheInputText from '@/components/shareComponents/TheInputText.vue';
import TheSelect from '@/components/shareComponents/TheSelect.vue';
import TheDateRangePicker from '@/components/shareComponents/TheDateRangePicker.vue';
import { lichSuDangNhapModel } from '@/models/quantri/lichSuDangNhap.model'
import { nguoiDungModel } from '@/models/quantri/nguoiDung.model'


export default {
    name: "TheLichSuDangNhapQT",
    components: {
        paginate: Paginate,
        loading: Loading,
        TheInputText,
        TheSelect,
        TheDateRangePicker,
    },
    data() {
        return {
            header: '',
            isBusy: false,
            filter: null,
            items: [],

            pageNumber: config.CURRENT_PAGE,
            pageSize: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,

            totalRow: 0,
            pageCount: 0,
            sortBy: null,
            orderDesc: true,
            numberOfShow: 0,
            title: null,
            code: null,
            styleButton: null,
            styleTitle: null,
            isReadonly: null,

            modelRec: lichSuDangNhapModel.newModel(),
            model: lichSuDangNhapModel.newFEModel(),
            modelNguoiDung: nguoiDungModel.newModel(),

            sValue_ID: null,
            sValue_PHANHE: null,
            sValue_NGUOIDUNG: null,
            sValue_NGAYLOGIN_fDate: null,
            sValue_NGAYLOGIN_tDate: null,
            sValue_SORT: null,

            category_PHANHE: [],
            category_NGUOIDUNG: [],

            cEnable_Value: null,
            checkEnable_Memo: false,


            csList: [],
            csList_Title: "",
            csList_Code: null,
            sType_List: 1,

            tempKey: common.randomString(10)
        }
    },
    methods: {
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('alert', ['warning',]),
        ...mapActions('lichSuDangNhapQT', ['getPagingLichSuDangNhapQT', 'getDetailLichSuDangNhapQT', 'deleteLichSuDangNhapQT', 'restoreLichSuDangNhapQT', 'handleListLichSuDangNhapQT']),
        ...mapActions('phanHeQT', ['getBasicPhanHeQT']),
        ...mapActions('nguoiDungQT', ['getBasicNguoiDungQT', 'getCustomDetailNguoiDungQT']),

        async setup() {
            let header = 'Lịch sử đăng nhập'
            this.setupHeader({ header })
        },

        async initialize() {

            $('#phanHe_sOptions').on('change', e => this.onChange_sPHANHE(e));

            $('#nguoiDung_sOptions').on('change', e => {
                let targetValue = e.target.value ? e.target.value : null
                if (!targetValue || targetValue == '') {
                    this.sValue_NGUOIDUNG = null
                    this.handlePageChange(1)
                }
                else {
                    let valueSelect = this.category_NGUOIDUNG.filter(e => e.id == targetValue)[0] ? this.category_NGUOIDUNG.filter(e => e.id == targetValue)[0] : null
                    this.sValue_NGUOIDUNG = valueSelect.id
                    this.handlePageChange(1)
                }
            });
        },


        async showModal() {
            $('#insUpdModal').modal('show')

        },
        async hideModal() {
            $('#insUpdModal').modal('hide')
            // await this.getData()
        },

        async showPopupDetail() {
            $('#detailModal').modal('show')
        },
        async hidePopupDetail() {
            $('#detailModal').modal('hide')
        },

        async showPopupUserDetail() {
            $('#detailUserModal').modal('show')
        },
        async hidePopupUserDetail() {
            $('#detailUserModal').modal('hide')
        },
        async showPopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('show')
        },
        async hidePopupconfirmcsListModal() {
            $('#confirmcsListModal').modal('hide')
            //await this.getData()
        },

        async handleSortChange(sortCol) {
            if (this.sortBy == sortCol) {
                if (this.orderDesc == true) {
                    this.sortBy = sortCol
                    this.orderDesc = false
                    this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
                }
                else if (this.orderDesc == false) {
                    this.orderDesc = null
                    this.sortBy = null
                    this.sValue_SORT = null
                }
            }
            else {
                this.sortBy = sortCol
                this.orderDesc = true
                this.sValue_SORT = sortCol + (this.orderDesc == true ? " desc" : " asc")
            }
            await this.getData()
        },
        async handlePageChange(page) {
            this.pageNumber = page
            await this.getData()
        },
        async onChangePageOptions(pageSize) {
            this.pageSize = pageSize
            await this.handlePageChange(1)
        },
        async onSearchKey() {
            this.pageNumber = config.CURRENT_PAGE
            await this.getData()
        },

        async isDate(value) {
            return value instanceof Date && !isNaN(value);
        },
        async fromDatetoString(input) {
            let day = null
            let month = null

            if (input.getUTCDate() >= 10) {
                day = "" + (input.getUTCDate())
            }
            else {
                day = "0" + (input.getUTCDate())
            }

            if (input.getUTCMonth() + 1 >= 10) {
                month = "" + (input.getUTCMonth() + 1)
            }
            else {
                month = "0" + (input.getUTCMonth() + 1)
            }
            return day + "/" + month + "/" + input.getUTCFullYear();
        },
        fromStringtoDate(dString) {
            var newDateTime = moment(dString, "DD/MM/YYYY").toDate();
            return newDateTime != 'Invalid Date' ? newDateTime : null;
        },
        async onSearchNgayLogin(e) {
            if (e) {
                if (!(await this.isDate(e.at(0))) || !(await this.isDate(e.at(1)))) {
                    this.$store.dispatch("alert/error", "Ngày không phù hợp", { root: true });
                    this.sValue_NGAYLOGIN_fDate = null
                    this.sValue_NGAYLOGIN_tDate = null
                }
                else {
                    this.sValue_NGAYLOGIN_fDate = e.at(0) ? await this.fromDatetoString(e.at(0)) : null
                    this.sValue_NGAYLOGIN_tDate = e.at(1) ? await this.fromDatetoString(e.at(1)) : null
                }

            }
            else {
                this.sValue_NGAYLOGIN_fDate = null
                this.sValue_NGAYLOGIN_tDate = null
            }
            await this.getData()
        },

        async changeCurrentTypeSearch() {
            if (this.sType_List == 2) this.sType_List = 1
            else if (this.sType_List == 1) this.sType_List = 2
            await this.handlePageChange(1)
        },

        async selectRow(loginHistoryId) {
            if (this.csList.includes(loginHistoryId)) {
                this.csList.splice(this.csList.indexOf(loginHistoryId), 1)
            }
            else {
                this.csList.push(loginHistoryId)
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.csList = this.items.map((item) => {
                    return item.loginHistoryId
                })
            }
            else {
                this.csList = []
            }
        },

        async onChange_sPHANHE(e) {
            let targetValue = e.target.value ? e.target.value : null
            if (!targetValue || targetValue == '') {
                this.sValue_PHANHE = null
                //
                this.category_NGUOIDUNG = []
                this.sValue_NGUOIDUNG = null
                //
                this.handlePageChange(1)
            }
            else {
                let valueSelect = this.category_PHANHE.filter(e => e.id == targetValue)[0] ? this.category_PHANHE.filter(e => e.id == targetValue)[0] : null
                this.sValue_PHANHE = valueSelect.id
                //
                this.category_NGUOIDUNG = []
                this.sValue_NGUOIDUNG = null
                this.category_NGUOIDUNG = await this.getCategory_NGUOIDUNG(this.sValue_PHANHE)
                //
                this.handlePageChange(1)
            }
        },

        async getData() {
            this.isBusy = true
            this.csList = []
            let params = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                appId: this.sValue_PHANHE,
                userId: this.sValue_NGUOIDUNG,
                loginTimeTungay: this.sValue_NGAYLOGIN_fDate,
                loginTimeDenngay: this.sValue_NGAYLOGIN_tDate,
                sort: this.sValue_SORT,
            }
            await this.getPagingLichSuDangNhapQT({ params: params, type: this.sType_List }).then(res => {
                // List data
                this.items = res.data
                if (this.items) {
                    for (let i = 0; i < this.items.length; i++) {
                        this.items[i].enabledDisplay = this.items[i].enabled == 1 ? true : false
                    }
                }

                // // Total row
                this.totalRow = res.totalRow
                // // Number show
                this.numberOfShow = !this.items ? 0 : ((this.pageNumber - 1) * this.pageSize) + this.items.length;
                // // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.pageSize)) + 1;
            });
            this.isBusy = false;
        },

        async detail(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            if (this.code == 'delete' && this.sType_List == 2) this.title = this.$t('labels.deleteReal')
            this.styleButton = this.$t('labels.styleButton' + code)
            this.styleTitle = this.$t('labels.styleTitle' + code)
            //this.errors = nguoiDungModel.errors()

            if (this.code == 'update' || this.code == 'delete' || this.code == 'restore') {
                let params = {
                    loginHistoryId: item.loginHistoryId
                }
                let resp = await this.getDetailLichSuDangNhapQT({ params }).then(async resp => {
                    if (resp == null) {
                        return
                    }
                    else {
                        this.modelRec = lichSuDangNhapModel.newModel()
                        this.modelRec = resp
                        this.model = this.modelRec

                    }
                });
                this.isReadonly = (code == "delete" || code == "restore") ? true : false
                this.tempKey = common.randomString(10)
                await this.showModal()

            }
            else if (this.code == 'detail') {
                let params = {
                    loginHistoryId: item.loginHistoryId
                }
                await this.getDetailLichSuDangNhapQT({ params }).then(resp => {
                    if (resp == null) {
                        return
                    }
                    else {

                        this.modelRec = lichSuDangNhapModel.newModel()
                        this.modelRec = resp
                        this.modelRec.roleInfo = resp.roleInfo
                        this.modelRec.appInfo = resp.appInfo
                    }
                });
                this.tempKey = common.randomString(10)
                this.showPopupDetail()
            }
            else {

                this.model = lichSuDangNhapModel.newFEModel()
                this.dValue_QUYEN = []
                //this.triggerDetail()
                this.isReadonly = (code == "create") ? false : true
                this.isReadonlyUserName = false
                //this.isReadonly = this.isReadonly = (code == "delete") ? true : false
                // show popup
                this.tempKey = common.randomString(10)
                this.showModal()
            }
        },

        async detailNguoiDung(item, code) {
            this.code = code
            this.title = this.$t('labels.' + code)
            this.styleButton = this.$t('labels.styleButton' + code)
            this.styleTitle = this.$t('labels.styleTitle' + code)

            let params = {
                userId: item.userId
            }
            await this.getCustomDetailNguoiDungQT({ params }).then(resp => {
                if (resp == null) {
                    return
                }
                else {

                    this.modelNguoiDung = nguoiDungModel.newModel()
                    this.modelNguoiDung = resp.userInfo
                    this.modelNguoiDung.appInfo = resp.appInfo
                    this.modelNguoiDung.roleInfo = resp.roleInfo
                }
            });
            this.showPopupUserDetail()

        },

        async onSubmit() {
            let code = this.code
            let res = false
            let params = null
            switch (code) {
                case "delete":
                    // eslint-disable-next-line
                    params = {
                        loginHistoryId: this.model.loginHistoryId
                    }
                    res = await this.deleteLichSuDangNhapQT({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "deleteReal":
                    // eslint-disable-next-line
                    params = {
                        loginHistoryId: this.model.loginHistoryId
                    }
                    res = await this.deleteLichSuDangNhapQT({ model: params, type: this.sType_List })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                case "restore":
                    // eslint-disable-next-line
                    params = {
                        loginHistoryId: this.model.loginHistoryId
                    }
                    res = await this.restoreLichSuDangNhapQT({ model: params })
                    if (res) {
                        await this.getData()
                        this.hideModal()
                    }
                    break
                default:
            }
        },

        async confirmList(code) {
            if (this.csList.length == 0) {
                this.warning(this.$t('labels.selectItem'))
            }
            else {
                this.csList_Code = code
                if (code == 'delete') this.csList_Title = "Xóa"
                else if (code == 'deleteReal') this.csList_Title = "Xóa hoàn toàn"
                else if (code == 'restore') this.csList_Title = "Khôi phục"
                this.showPopupconfirmcsListModal()
            }

        },

        async onSubmitList() {
            let code = this.csList_Code
            let t = null
            let params = {
                listId: this.csList.toString()
            }
            // if(code == "offEnebaled") params.enabled = false
            // else if(code == "onEnebaled") params.enabled = true
            let res = null
            switch (code) {
                case "delete":
                    res = await this.handleListLichSuDangNhapQT({ model: params, type: 1 })
                    break
                case "deleteReal":
                    res = await this.handleListLichSuDangNhapQT({ model: params, type: 2 })
                    break
                case "restore":
                    res = await this.handleListLichSuDangNhapQT({ model: params, type: 3 })
                    break
                case "offEnabled":
                    params.enabled = false
                    res = await this.handleListLichSuDangNhapQT({ model: params, type: 4 })
                    break
                case "onEnabled":
                    params.enabled = true
                    res = await this.handleListLichSuDangNhapQT({ model: params, type: 4 })
                    break
                default:
            }
            if (res) {
                await this.getData()
                this.hidePopupconfirmcsListModal()
            }
        },

        async getCategory_PHANHE() {
            let params = {
            }
            let res = await this.getBasicPhanHeQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].appId,
                            name: res[i].appName
                        }
                    )
                }
                return handleRes
            }
            return res
        },

        async getCategory_NGUOIDUNG(appId) {
            let params = {
                appId: appId
            }
            let res = await this.getBasicNguoiDungQT({ params: params })
            //handle
            //Lý do cần xử lý là để format lại theo mô hình
            if (res.length > 0) {
                let handleRes = []
                for (let i = 0; i < res.length; i++) {
                    handleRes.push(
                        {
                            id: res[i].userId,
                            name: res[i].userName + ' - ' + res[i].hoTen
                        }
                    )
                }
                return handleRes
            }
            return res
        },
    },

    async mounted() {
        await this.initialize()
        await this.setup()
        await this.getData()

        this.category_PHANHE = await this.getCategory_PHANHE()
        //this.category_NGUOIDUNG = await this.getCategory_NGUOIDUNG()
    }


}
</script>
<style></style>